import {Component, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import {NetworkProviderType} from '@shared/services/api/access-sites.interface';
import {Subject} from 'rxjs';
import {AceSelectComponent} from '../../ace-select/ace-select.component';
import {finalize} from 'rxjs/operators';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MessageTranslateService, NetworkProvidersService} from '@shared/services';

@Component({
  selector: 'app-network-provider-type-select',
  templateUrl: './network-provider-type-select.component.html',
  styleUrls: ['./network-provider-type-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NetworkProviderTypeSelectComponent),
      multi: true
    }
  ],
  standalone: false
})
export class NetworkProviderTypeSelectComponent implements OnInit, ControlValueAccessor {

  readonly MAX_ITEMS = 3;

  selectedNetworkProviderTypes: number[] | NetworkProviderType[];
  networkProviderTypes: NetworkProviderType[];

  @Input()
  id: string;
  @Input()
  required: boolean;
  @Input()
  class: string;
  @Input()
  multiSelect = false;
  @Input()
  placeholder: string;
  @Input()
  appendTo: string;
  @Input()
  bindToTypeId = false;

  loading: boolean;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  @ViewChild('aceSelect', { static: true })
  private aceSelect: AceSelectComponent;

  private onChange: (_) => void = (_) => {};
  private onTouched: () => void = () => {};

  constructor(private translateService: MessageTranslateService,
              private networkProvidersService: NetworkProvidersService) {
  }

  ngOnInit() {
    this.loading = true;
    this.networkProvidersService.getNetworkProviderTypes().pipe(finalize(() => this.loading = false))
      .subscribe((networkProviderTypes) => {
        this.networkProviderTypes = networkProviderTypes;
      });

    if (this.placeholder === undefined) {
      this.placeholder = this.translateService.instant('Select Network Provider Type');
    }

    this.aceSelect.registerOnChange(this.aceSelectChange);
    this.aceSelect.registerOnTouched(this.aceSelectTouched);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.aceSelect.setDisabledState(isDisabled);
  }

  aceSelectChange = (selected: number | number[] | NetworkProviderType | NetworkProviderType[]) => {
    this.selectedNetworkProviderTypes = this.toSelectedArray(selected);
    this.onChange(selected);
  };

  aceSelectTouched = () => {
    this.onTouched();
  };

  writeValue(value: any): void {
    this.selectedNetworkProviderTypes = this.toSelectedArray(value);
    this.aceSelect.writeValue(value);
  }

  private toSelectedArray(value: number | number[] | NetworkProviderType | NetworkProviderType[]): number[] | NetworkProviderType[] | null {
    if (value == null) {
      return null;
    }
    if (Array.isArray(value)) {
      return value;
    }
    return <number[] | NetworkProviderType[]> [value];
  }

  compareFn(a: NetworkProviderType, b: NetworkProviderType): boolean {
    return a.network_provider_type_id === b.network_provider_type_id;
  }

}
